import {
  Avatar,
  Button,
  Tooltip,
  Typography,
} from "@mui/material";
import { DamsColors } from "../styles/DamsColors";

import { DamsAppAsset } from "../../assets/registry";

export type CustomBtnProps = {
  height?: number;
  width?: number | "auto";
  label?:string,
  tip?:string,
  onClick:()=>void
};

function FilterItemButton({
  label = "Btn Title",
  height = 40,
  width = "auto",
  onClick,
  tip

}: CustomBtnProps) {
  const btnStyles = {
    width: typeof width === "number" ? `${width}px` : width,
    height: `${height}px`,
    ...styles.outlinedBtn,
  
  };

  const fontColor =  DamsColors.Text.PrimaryText;
  return (
    <Tooltip title={tip} arrow  >
          <Button
      sx={{ ...styles.btnContainer, ...btnStyles }}
      endIcon={
        
          <Avatar
           onClick={onClick}
              src={DamsAppAsset.icons.close_green}
              alt="btn Icon"
              sx={styles.btnIcon}
              variant="square"
          />

      }
      variant={'outlined'}
    >
        <Typography
          fontFamily={"Inter"}
          fontWeight={600}
          fontSize={14}
          color={fontColor}
          noWrap
          sx={styles.btnText}
        >
          {label}
        </Typography>
  
    </Button>
    </Tooltip>
  
  );
}

const styles = {
  btnContainer: {
    // border: '1pc solid blue',
    // gap: 1
    borderRadius: "8px",
    marginLeft:1,
    marginBottom:1

  },

  btnIcon: {
    width: "20px",
    height: "20px",
  },

  btnText: {
    textTransform: "none",
  },

  outlinedBtn: {
    border: `1px solid ${DamsColors.Border.FooterDivider}`,

    "&:hover": {
      backgroundColor: DamsColors.SideBar.SideBarContainer,
      border: `1px solid ${DamsColors.Border.FooterDivider}`,
    },
  },
};

export { FilterItemButton };
